import React from 'react';

export default React.createContext({
  step: 1,
  progress: 1,
  displayText: {},
  filters: {
    group: '',
    family: '',
    grade: '',
    gender: ''
  },
  results: [],
  getResults: () => {},
  clearResults: () => {},
  getDisplayText: () => {},
  setStep: step => {},
  setProgress: progress => {},
  setFilters: filters => {}
})